import { isEmpty } from 'ramda'
export const ellipsisString = (string = '', characters) => {
  if (!isEmpty(string)) {
    return string.length > Number(characters)
      ? string.substr(0, characters) + '...'
      : string
  } else {
    return ''
  }
}

export const maskEmail = (email) => {
  if (!email || !email.includes('@')) return '***'
  const [, domain] = email.split('@')
  return `***@${domain}`
}
